import { z } from "zod";

import { mediaSchema } from "@/common/schemas";

export const articleCardPropsSchema = z.object({
  image: mediaSchema,
  category: z.string().min(3),
  title: z.string().min(3),
  description: z.string().min(3),
  timeToRead: z.string().min(3),
  date: z.string().min(3),
  link: z.string().min(3),
});
